/* Eigen dropdown voor keuzevelden op de accessoirepagina (opdracht Moniem 18-10-2026).
   Breidt een bestaand <select data-pf-dropdown> uit: het native veld blijft bestaan (waarde, change-event, bestaande
   logica in pf-pdp-acc.js), maar de keuzelijst opent als eigen paneel direct onder (of boven) het veld, ook op
   Android en iPhone, in plaats van het systeemvenster. Optgroups worden kopjes; de gekozen optie krijgt een vinkje.
   Bediening: tik/klik, pijltjes, Home/End, Enter/spatie, typen om te zoeken, Escape en Tab; buiten tikken sluit. */
(function () {
  'use strict';
  let uid = 0;
  const CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  function enhance(select) {
    if (select.dataset.pfDropdownReady) return;
    select.dataset.pfDropdownReady = '1';
    const id = 'pfdd-' + (++uid);
    const box = select.parentElement;
    box.classList.add('pf-dd');
    const label = select.id ? document.querySelector('label[for="' + select.id + '"]') : null;
    if (label && !label.id) label.id = id + '-label';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = select.className + ' pf-dd__btn';
    btn.id = id + '-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id + '-list');
    if (label) { btn.setAttribute('aria-labelledby', label.id + ' ' + btn.id); label.htmlFor = btn.id; }
    const btnText = document.createElement('span'); btnText.className = 'pf-dd__value'; btn.append(btnText);

    const list = document.createElement('div');
    list.className = 'pf-dd__list'; list.id = id + '-list'; list.setAttribute('role', 'listbox'); list.tabIndex = -1; list.hidden = true;
    if (label) list.setAttribute('aria-labelledby', label.id);

    select.classList.add('pf-dd__native'); select.tabIndex = -1; select.setAttribute('aria-hidden', 'true');
    select.after(btn); box.append(list);

    let opts = [], active = -1, typed = '', typedAt = 0;
    function build() {
      list.replaceChildren(); opts = [];
      const add = (o, parent) => {
        const it = document.createElement('div');
        it.className = 'pf-dd__opt'; it.setAttribute('role', 'option'); it.id = id + '-o' + opts.length; it.dataset.value = o.value;
        it.innerHTML = '<span class="pf-dd__txt"></span><span class="pf-dd__check">' + CHECK + '</span>';
        it.querySelector('.pf-dd__txt').textContent = o.textContent.trim();
        if (o.disabled) it.setAttribute('aria-disabled', 'true');
        it.addEventListener('click', e => { e.preventDefault(); if (!o.disabled) choose(opts.indexOf(it)); });
        it.addEventListener('mousemove', () => setActive(opts.indexOf(it), false));
        (parent || list).append(it); opts.push(it);
      };
      [...select.children].forEach(ch => {
        if (ch.tagName === 'OPTGROUP') {
          const g = document.createElement('div'); g.className = 'pf-dd__group'; g.setAttribute('role', 'group');
          const h = document.createElement('div'); h.className = 'pf-dd__head'; h.id = id + '-g' + list.children.length; h.textContent = ch.label; h.setAttribute('role', 'presentation');
          g.setAttribute('aria-labelledby', h.id); g.append(h); list.append(g);
          [...ch.children].forEach(o => add(o, g));
        } else if (ch.tagName === 'OPTION') add(ch);
      });
      sync();
    }
    function sync() {
      const i = select.selectedIndex, cur = select.options[i];
      btnText.textContent = cur ? cur.textContent.trim() : '';
      opts.forEach(o => { const on = cur && o.dataset.value === cur.value; o.setAttribute('aria-selected', String(!!on)); o.classList.toggle('is-selected', !!on); });
    }
    function setActive(i, scroll) {
      if (i < 0 || i >= opts.length) return;
      if (opts[active]) opts[active].classList.remove('is-active');
      active = i; opts[i].classList.add('is-active');
      list.setAttribute('aria-activedescendant', opts[i].id);
      if (scroll !== false) opts[i].scrollIntoView({ block: 'nearest' });
    }
    function place() {
      // Onder het veld; past dat niet en is er boven meer ruimte, dan erboven. Altijd binnen het scherm, lijst scrollt zelf.
      const r = btn.getBoundingClientRect(), vh = window.innerHeight, gap = 6, margin = 12;
      const below = vh - r.bottom - gap - margin, above = r.top - gap - margin;
      list.style.maxHeight = '';
      const natural = Math.min(list.scrollHeight, 340);
      const up = below < natural && above > below;
      list.classList.toggle('is-up', up);
      list.style.maxHeight = Math.max(140, Math.min(340, up ? above : below)) + 'px';
    }
    function open() {
      if (!list.hidden) return;
      build(); list.hidden = false; btn.setAttribute('aria-expanded', 'true'); box.classList.add('is-open');
      place();
      const sel = opts.findIndex(o => o.getAttribute('aria-selected') === 'true');
      setActive(sel >= 0 ? sel : 0);
      list.focus({ preventScroll: true });
      document.addEventListener('pointerdown', outside, true);
      window.addEventListener('resize', place);
    }
    function close(focusBtn) {
      if (list.hidden) return;
      list.hidden = true; btn.setAttribute('aria-expanded', 'false'); box.classList.remove('is-open'); list.classList.remove('is-up');
      document.removeEventListener('pointerdown', outside, true);
      window.removeEventListener('resize', place);
      if (focusBtn) btn.focus({ preventScroll: true });
    }
    function outside(e) { if (!box.contains(e.target)) close(false); }
    function choose(i) {
      const it = opts[i]; if (!it || it.getAttribute('aria-disabled') === 'true') return;
      const changed = select.value !== it.dataset.value;
      select.value = it.dataset.value; sync(); close(true);
      if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    btn.addEventListener('click', () => (list.hidden ? open() : close(true)));
    btn.addEventListener('keydown', e => { if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) { e.preventDefault(); open(); } });
    list.addEventListener('keydown', e => {
      const k = e.key;
      if (k === 'ArrowDown') { e.preventDefault(); setActive(Math.min(opts.length - 1, active + 1)); }
      else if (k === 'ArrowUp') { e.preventDefault(); setActive(Math.max(0, active - 1)); }
      else if (k === 'Home') { e.preventDefault(); setActive(0); }
      else if (k === 'End') { e.preventDefault(); setActive(opts.length - 1); }
      else if (k === 'Enter' || k === ' ') { e.preventDefault(); choose(active); }
      else if (k === 'Escape') { e.preventDefault(); close(true); }
      else if (k === 'Tab') { close(false); }
      else if (k.length === 1 && /\S/.test(k)) {
        const now = Date.now(); typed = (now - typedAt > 700 ? '' : typed) + k.toLowerCase(); typedAt = now;
        const start = active + (typed.length === 1 ? 1 : 0);
        const order = opts.slice(start).concat(opts.slice(0, start));
        const hit = order.find(o => o.textContent.trim().toLowerCase().replace(/^iphone\s*/, '').startsWith(typed) || o.textContent.trim().toLowerCase().startsWith(typed));
        if (hit) setActive(opts.indexOf(hit));
      }
    });
    list.addEventListener('focusout', e => { if (!box.contains(e.relatedTarget)) close(false); });
    // Andere scripts (bijv. "· jouw toestel" of een voorkeuze) passen het native veld aan: knoptekst volgt.
    select.addEventListener('change', sync);
    select.addEventListener('pf-dropdown-sync', sync);
    new MutationObserver(sync).observe(select, { subtree: true, childList: true, characterData: true, attributes: true });
    build();
  }

  function init() { document.querySelectorAll('select[data-pf-dropdown]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // De voorkeuze van pf-pdp-acc.js zet select.value zonder event: na het laden nog één keer de knoptekst bijwerken.
  window.addEventListener('load', () => document.querySelectorAll('select[data-pf-dropdown]').forEach(s => s.dispatchEvent(new Event('pf-dropdown-sync'))));
  window.PrimeFoneDropdown = { enhance };
})();
